module.exports = __webpack_public_path__ + "static/media/3 11 Tulleord Peano er feil-norming.e336800a.mp3";